import React from 'react'
import ClosureSurvey from 'sprockets_react/closure_survey/registry'
import ClosureSurveyData from 'sprockets_react/closure_survey/data/registry'

ClosureSurvey.RateExperience = {
  onSubmit: function(onStepProgression, onRequest, onRequestCompletion) {
    onStepProgression()
  },

  onLeftNavButtonClick(onStepProgression, trigger) {
    if (ClosureSurveyData.Data.providerAccountId !== null && trigger === 'hire_button') {
      ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.HasJobBeenDoneYet)
    }
    else {
      ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.WhoDidTheJob)
    }
  },

  buttonLayout: function() {
    return 'none'
  },

  component: React.createClass({
    getInitialState: function() {
      const closureSurvey = ClosureSurveyData.Data;

      return {
        rating: closureSurvey.rating,
        starClassDefault: "font-24 text-copy-0 p8 "
      }
    },

    componentDidMount: function() {
      $('#job-closure-modal').bootstrapValidator({})
      ClosureSurvey.RateExperience.validator = $('#job-closure-modal').data('bootstrapValidator')
    },

    handleRatingClick: function(e, value) {
      ClosureSurveyData.Data.rating = value
      this.setState({ rating: value })
    },

    changeStarToFull: function($star) {
      $star.removeClass("ficon-star-empty")
           .addClass("ficon-star-full")
    },

    changeStarToEmpty: function($star) {
      $star.removeClass("ficon-star-full")
           .addClass("ficon-star-empty")
    },

    handleMouseHoverOnStarOne: function(e) {
      this.changeStarToFull($('#survey_feedback_rating_1'))
      this.changeStarToEmpty($('#survey_feedback_rating_2'))
      this.changeStarToEmpty($('#survey_feedback_rating_3'))
      this.changeStarToEmpty($('#survey_feedback_rating_4'))
      this.changeStarToEmpty($('#survey_feedback_rating_5'))
    },

    handleMouseOutOnStarOne: function(e) {
      this.changeStarToEmpty($('#survey_feedback_rating_1'))
    },

    handleMouseHoverOnStarTwo: function(e) {
      this.handleMouseHoverOnStarOne()
      this.changeStarToFull($('#survey_feedback_rating_2'))
    },

    handleMouseOutOnStarTwo: function(e) {
      this.handleMouseOutOnStarOne()
      this.changeStarToEmpty($('#survey_feedback_rating_2'))
    },

    handleMouseHoverOnStarThree: function(e) {
      this.handleMouseHoverOnStarTwo()
      this.changeStarToFull($('#survey_feedback_rating_3'))
    },

    handleMouseOutOnStarThree: function(e) {
      this.handleMouseOutOnStarTwo()
      this.changeStarToEmpty($('#survey_feedback_rating_3'))
    },

    handleMouseHoverOnStarFour: function(e) {
      this.handleMouseHoverOnStarThree()
      this.changeStarToFull($('#survey_feedback_rating_4'))
    },

    handleMouseOutOnStarFour: function(e) {
      this.handleMouseOutOnStarThree()
      this.changeStarToEmpty($('#survey_feedback_rating_4'))
    },

    handleMouseHoverOnStarFive: function(e) {
      this.handleMouseHoverOnStarFour()
      this.changeStarToFull($('#survey_feedback_rating_5'))
    },

    handleMouseOutOnStarFive: function(e) {
      this.handleMouseOutOnStarFour()
      this.changeStarToEmpty($('#survey_feedback_rating_5'))
    },

    handleMouseOutOnAllStars: function(e) {
      if (this.state.rating) {
        this.handleMouseHoverOnStarOne()
      }
      if (parseInt(this.state.rating) >= 2) {
        this.handleMouseHoverOnStarTwo()
      }
      if (parseInt(this.state.rating) >= 3) {
        this.handleMouseHoverOnStarThree()
      }
      if (parseInt(this.state.rating) >= 4) {
        this.handleMouseHoverOnStarFour()
      }
      if (parseInt(this.state.rating) == 5) {
        this.handleMouseHoverOnStarFive()
      }
    },

    handleCommentsOnChange: function(e) {
      ClosureSurveyData.Data.comments = e.target.value
    },

    renderNavButton() {
      return (
        <div>
          { ClosureSurveyData.Data.rating ?
            <div className="pt30">
              <ClosureSurvey.NavigationButtons
                navButtonLayout="default"
                onStepProgression={this.props.onStepProgression}
                onStepRetreat={this.props.onStepRetreat}
              />
            </div>
            :
            <div className="pt30">
              <ClosureSurvey.NavigationButtons
                navButtonLayout="submitButton"
                label="No thanks, I don't want to leave a rating yet"
                onStepProgression={this.props.onStepProgression}
              />
              <div className="pt30">
                <ClosureSurvey.NavigationButtons
                  navButtonLayout="backButton"
                  onStepRetreat={this.props.onStepRetreat}
                />
              </div>
            </div>
          }
        </div>
      )
    },

    renderNavButtonFastFeedback() {
      return (
        <div>
          { ClosureSurveyData.Data.rating ?
              <div className="pt30">
                <ClosureSurvey.NavigationButtons
                  navButtonLayout="nextButton"
                  onStepProgression={this.props.onStepProgression}
                />
              </div>
            :
            <div className="pt30">
              <ClosureSurvey.NavigationButtons
                navButtonLayout="submitButton"
                label="No thanks, I don't want to leave a rating yet"
                onStepProgression={this.props.onStepProgression}
              />
            </div>
          }
        </div>
      )
    },

    render() {
      return (
        <div>
          <h3 className="mb15 mt20">Rate your experience with {ClosureSurveyData.Data.providerAccountName}</h3>
          <div className="form-group">
            <div className="col-xs-12 white-box bordered text-center p20 pt32 pb32 mb30 radius-6" id="star-rating-input" onMouseOut={this.handleMouseOutOnAllStars}>
              <span className={this.state.starClassDefault + (this.state.rating ? "ficon-star-full" : "ficon-star-empty")}
                    id="survey_feedback_rating_1"
                    onMouseOver={this.handleMouseHoverOnStarOne}
                    onMouseOut={this.handleMouseOutOnStarOne}
                    onClick={(e) => this.handleRatingClick(e, "1")}>
              </span>
              <span className={this.state.starClassDefault + ((parseInt(this.state.rating) >= 2) ? "ficon-star-full" : "ficon-star-empty")}
                    id="survey_feedback_rating_2"
                    onMouseOver={this.handleMouseHoverOnStarTwo}
                    onMouseOut={this.handleMouseOutOnStarTwo}
                    onClick={(e) => this.handleRatingClick(e, "2")}>
              </span>
              <span className={this.state.starClassDefault + ((parseInt(this.state.rating) >= 3) ? "ficon-star-full" : "ficon-star-empty")}
                    id="survey_feedback_rating_3"
                    onMouseOver={this.handleMouseHoverOnStarThree}
                    onMouseOut={this.handleMouseOutOnStarThree}
                    onClick={(e) => this.handleRatingClick(e, "3")}>
              </span>
              <span className={this.state.starClassDefault + ((parseInt(this.state.rating) >= 4) ? "ficon-star-full" : "ficon-star-empty")}
                    id="survey_feedback_rating_4"
                    onMouseOver={this.handleMouseHoverOnStarFour}
                    onMouseOut={this.handleMouseOutOnStarFour}
                    onClick={(e) => this.handleRatingClick(e, "4")}>
              </span>
              <span className={this.state.starClassDefault + ((parseInt(this.state.rating) == 5) ? "ficon-star-full" : "ficon-star-empty")}
                    id="survey_feedback_rating_5"
                    onMouseOver={this.handleMouseHoverOnStarFive}
                    onMouseOut={this.handleMouseOutOnStarFive}
                    onClick={(e) => this.handleRatingClick(e, "5")}>
              </span>
            </div>
            { (this.state.rating) &&
              <div>
                <label className="mb5 mt20">Leave a comment (Optional)</label>
                <textarea
                  className="component-block mt15 mb10 p16 h120 form-control radius-6"
                  id="survey_feedback_comments"
                  name="survey_feedback_comments"
                  onChange={this.handleCommentsOnChange}
                />
                <a href={this.props.reviewGuidelines} target="_blank">
                  Guidelines for reviews
                </a>
              </div>
            }
            { this.props.fromFastFeedback ?
              this.renderNavButtonFastFeedback()
              :
              this.renderNavButton()
            }
          </div>
        </div>
      )
    }
  })
}

